export const userProfileTestData = {
    personalData: [
        "User Data",
        "hanspeter.peterle@muster.com",
        "Change password",
        "Personal Data",
        "Mr. Hans-Peter Peterle",
        "Position XYZ",
        "Contact Data",
        "Phone: +49 173 5837403",
        "Fax: +49 154 628302",
        "Department",
        "Fertigung Stanzwerkzeuge",
        "Reason for your registration",
        "Lorem Ipsum dolor",
    ],

    notificationSettings: [
        "Notification permissions",
        "Turn off all notifications",
        "Activate notifications",
        "Notification types",
        "Error",
        "Warning",
        "Information",
    ],

    companyData: [
        "Company Name",
        "Customer Number",
        "7129030JKSL",
        "Address",
        "Musterstrasse 13",
        "70184 Stuttgart",
        "Germany",
        "Telephone Number",
        "+ 49 172 1234567",
        "Fax Number",
        "+ 49 162 1234567",
    ],

    permissions: [
        "Your assigned permission role",
        "Purchaser",
        "Request different role",
    ],

    deleteAccount: [
        "Meinen MyTRUMPF Account löschen",
        "Sie möchten Ihren MyTRUMPF Account löschen?",
        "Bitte beachten Sie, dass wir lediglich Ihren persönlichen Account löschen werden",
        "Sollten weitere Kolleginnen oder Kollegen in Ihrem Unternehmen einen Account haben",
        "mit der Löschung dieses Accounts auch die Zugriffe auf den TRUMPF E-Shop und die Service App verloren gehen",
        "sowie die Möglichkeit, Schulungen online zu buchen",
    ],
};
